import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import Form from 'react-bootstrap/Form'
import { Link } from 'react-router-dom'
import { OutboundLink } from 'react-ga'
import PropTypes from 'prop-types'
import styles from '../styles/CombosPanel.module.scss'
import { v4 } from 'uuid'

const CombosPanel = ({ card, combos }) => {
  const commanderSpellbookLink = `https://commanderspellbook.com/search/?q=${card.name}`
  return (
    <div className={styles.container}>
      <h5 className='title'>Top Combos</h5>
      <Card className='shadow-sm'>
        <Card.Body>
          <Form>
            <Form.Group>
              {combos?.slice(0, -1).map(({ alt, href, value }) => (
                <div key={v4()}>
                  <Link alt={alt} to={href}>
                    {value}
                  </Link>
                </div>
              ))}
            </Form.Group>
            <Form.Group className={styles.moreCombos}>
              <Form.Label lg={2}>More Combos:</Form.Label>
              <Link to={`/combos/${card.sanitized_wo}`}>
                <Button>EDHREC</Button>
              </Link>
              <OutboundLink
                alt='Combo Spellbook'
                eventLabel={commanderSpellbookLink}
                target='_blank'
                to={commanderSpellbookLink}
              >
                <Button>Commander Spellbook</Button>
              </OutboundLink>
            </Form.Group>
          </Form>
        </Card.Body>
      </Card>
    </div>
  )
}

CombosPanel.propTypes = {
  card: PropTypes.any,
  combos: PropTypes.any,
}

export default CombosPanel
